import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SiteProvider, useSite } from './content/SiteContext';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ProjectsSection from './components/ProjectsSection';
import AwardsSection from './components/AwardsSection';
import AdvergamesSection from './components/AdvergamesSection';
import QuoteSection from './components/QuoteSection';
import BrandsSection from './components/BrandsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import ScrollToTopButton from './components/ScrollToTopButton';

// El panel se descarga solo al entrar a /admin
const AdminApp = lazy(() => import('./admin/AdminApp'));

const PublicSite = () => {
  const { ready } = useSite();

  if (!ready) {
    return <div className="min-h-screen" style={{ background: 'linear-gradient(-45deg, #1e1b4b, #4c1d95)' }} />;
  }

  return (
    <div className="App">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <ProjectsSection />
        <AwardsSection />
        <AdvergamesSection />
        <QuoteSection />
        <BrandsSection />
        <ContactSection />
      </main>
      <Footer />
      <ScrollToTopButton />
    </div>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={<div className="min-h-screen bg-gray-950" />}>
              <AdminApp />
            </Suspense>
          }
        />
        <Route
          path="*"
          element={
            <SiteProvider>
              <PublicSite />
            </SiteProvider>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
